export default "__VITE_ASSET__C2Ysqh33__"